module.exports = __webpack_public_path__ + "static/media/ca.6b4ef5b3.webp";